import "../node_modules/swiper/swiper-bundle.min.css";

import { Global } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import GlobalDialog from "@src/component/GlobalDialog";
import GlobalInit from "@src/component/GlobalInit";
import GlobalLoding from "@src/component/GlobalLoading";
import GlobalSnackbar from "@src/component/GlobalSnackbar";
import OnepointHeader from "@src/component/base/OnepointHeader";
import { globalColorCss } from "@src/ruix";
import theme from "@src/theme";
import http from "http";
import App, { AppContext, AppProps } from "next/app";
import { QueryClient, QueryClientProvider } from "react-query";
import { RecoilRoot } from "recoil";
import "../public/global.css";

const queryClient = new QueryClient();

interface OnepointAppProps extends AppProps {
	authKey?: string;
}

function MyApp({ Component, pageProps, authKey }: OnepointAppProps) {
	return (
		<>
			<OnepointHeader meta={(pageProps as any)?.meta} />
			<QueryClientProvider client={queryClient}>
				<ThemeProvider theme={theme}>
					<Global styles={globalColorCss}></Global>
					<CssBaseline />
					<RecoilRoot>
						<Component {...pageProps} />
						<GlobalSnackbar />
						<GlobalLoding />
						<GlobalInit authKey={authKey} />
						<GlobalDialog />
					</RecoilRoot>
				</ThemeProvider>
			</QueryClientProvider>
		</>
	);
}

// A regular expression used for matching a www domain
const wwwRegex = /^www\./;

function redirectWwwToNonWww(req: http.IncomingMessage, res: http.ServerResponse, path: string) {
	if (wwwRegex.test(String(req?.headers?.host))) {
		const newHost = String(req?.headers?.host).replace(wwwRegex, "");
		res.writeHead(301, { location: `https://${newHost}${path}` });
		res.end();
		return false;
	}
	return true;
}

// Run server-side code on each request
MyApp.getInitialProps = async (appContext: AppContext) => {
	const result = redirectWwwToNonWww(
		appContext.ctx.req!,
		appContext.ctx.res!,
		appContext.router.asPath,
	);
	if (!result) return {};
	const { authKey } = appContext.ctx.query!;
	const appProps = await App.getInitialProps(appContext);
	return { ...appProps, authKey };
};

export default MyApp;
